import BaseIcon from './BaseIcon';
import React, { ReactElement, SVGProps } from 'react';

export default function BankIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M2.25 9h19.5L12 3 2.25 9Zm3 0v7.5M9.75 9v7.5m4.5-7.5v7.5m4.5-7.5v7.5M3 16.5h18m-19.5 3h21"
        stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
      />
    </BaseIcon>
  );
}
